"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _constants = require("./constants");

var _PopoverBoundary = _interopRequireDefault(require("./PopoverBoundary"));

var _PopoverContent = _interopRequireDefault(require("./PopoverContent"));

var _Popover = _interopRequireDefault(require("./Popover.style"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

const TRIGGER_EVENTS = {
  click: 'click',
  contextmenu: 'contextmenu',
  mouseover: 'mouseover',
  focus: 'focus' // Add more event mappings here as needed

};
const TRIGGER_EVENTS_TO_CALLBACKS = {
  [TRIGGER_EVENTS.click]: 'onClick',
  [TRIGGER_EVENTS.contextmenu]: 'onContextMenu',
  [TRIGGER_EVENTS.mouseover]: 'onMouseOver',
  [TRIGGER_EVENTS.focus]: 'onFocus'
};
const StyledPopover = (0, _reactJss.default)(_Popover.default)((_ref) => {
  var _ref2;

  let {
    trigger,
    content,
    topLevel,
    opened: openedProp,
    children,
    classes,
    onClose,
    className,
    bindingElementRef: bindingElementRefProp,
    contentClassName,
    byClickPosition,
    onToggle,
    toggleOnRepeatedClick,
    dataTestId
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["trigger", "content", "topLevel", "opened", "children", "classes", "onClose", "className", "bindingElementRef", "contentClassName", "byClickPosition", "onToggle", "toggleOnRepeatedClick", "dataTestId"]);
  const [opened, setOpened] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => onToggle === null || onToggle === void 0 ? void 0 : onToggle(opened), [opened]);
  const bindingElementRef = (0, _react.useRef)(null);
  const {
    boundaryRef,
    globalBoundaryRef
  } = (0, _react.useContext)(_PopoverBoundary.default.Context);
  const [clickPosition, setClickPosition] = (0, _react.useState)(null);

  const saveClickPosition = e => {
    if (byClickPosition) {
      setClickPosition({
        x: e.clientX + window.scrollX,
        y: e.clientY + window.scrollY
      });
    }
  };

  const [mounted, setMounted] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setMounted(true);
  }, []);
  const handleToggle = (0, _react.useCallback)(e => {
    if (openedProp !== null) return;
    saveClickPosition(e);
    setOpened(prevOpened => !prevOpened);
  }, [openedProp]);
  const handleOpen = (0, _react.useCallback)(e => {
    if (openedProp !== null) return;
    saveClickPosition(e);
    setOpened(true);
  }, [openedProp]);
  const handleClose = (0, _react.useCallback)((e, ...args) => {
    if (openedProp !== null) return;

    if (onClose) {
      onClose(...args);
    }

    setOpened(false);
  }, [openedProp]);
  /**
   * WARNING: Currently there is a problem with popover reopening right after closing.
   * This happens when click was made inside popover content on the some kind of "Close" or "Submit" buttons.
   * To resolve this problem there is need in additional div adding for separate
   * handling events on the binding element and popover content, which is imposible with current
   * Selects, TextFields, etc. which are using popovers.
   * So temporary solution is to call onClose with setTimeout, after all opening callbacks have been  already called
   */

  const handleCloseAsync = (0, _react.useCallback)((...args) => setTimeout(() => handleClose(...args), 0), [handleClose]);
  const triggers = Array.isArray(trigger) ? trigger : [trigger];
  const openingCallbacks = (0, _react.useMemo)(() => triggers.reduce((acc, trigger) => {
    const callback = trigger === TRIGGER_EVENTS.click && toggleOnRepeatedClick ? handleToggle : handleOpen;
    acc[TRIGGER_EVENTS_TO_CALLBACKS[trigger] || trigger] = callback;
    return acc;
  }, {}), [triggers, handleOpen]);
  const PopoverWrap = (0, _react.useCallback)(({
    children
  }) => bindingElementRefProp ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children) : /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx.default)(className, classes.popoverParent),
    ref: bindingElementRef,
    "data-testid": dataTestId
  }, openingCallbacks), children), [bindingElementRefProp, openingCallbacks, className]);
  const isOpened = openedProp === null ? opened : openedProp;
  return /*#__PURE__*/_react.default.createElement(PopoverWrap, null, (0, _react.isValidElement)(children) ? children : children(_objectSpread(_objectSpread({}, openingCallbacks), {}, {
    onToggle: handleToggle,
    opened: isOpened
  })), mounted && isOpened && content ? /*#__PURE__*/_react.default.createElement(_PopoverContent.default, (0, _extends2.default)({
    bindingElement: (bindingElementRefProp === null || bindingElementRefProp === void 0 ? void 0 : bindingElementRefProp.current) || bindingElementRef.current,
    boundaryElement: (_ref2 = topLevel ? globalBoundaryRef : boundaryRef) === null || _ref2 === void 0 ? void 0 : _ref2.current,
    topLevel: topLevel,
    triggers: triggers,
    clickPosition: clickPosition,
    onClose: handleClose,
    className: contentClassName,
    dataTestId: dataTestId ? `${dataTestId}-content` : undefined
  }, props), (0, _react.isValidElement)(content) ? content : content({
    onClose: handleCloseAsync
  })) : null);
});

const Popover = props => /*#__PURE__*/_react.default.createElement(StyledPopover, props);

Popover.ANCHOR = _constants.ANCHOR;
Popover.defaultProps = {
  trigger: [TRIGGER_EVENTS.click, TRIGGER_EVENTS.contextmenu],
  topLevel: false,
  opened: null,
  byClickPosition: false,
  toggleOnRepeatedClick: false
};
var _default = Popover;
exports.default = _default;